<template>
    <div>
        <span class="text-success">
            <i
                class="fa fa-plus-circle fa-lg icon-button"
                title="Selecionar item"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencherModal()">
            <div slot="modal-title">Informe valor do item da requisição</div>
            <b-row>
                <b-col sm="12">
                    <detalhe
                        titulo="Código"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.idItemContrato }}</detalhe
                    >
                    <detalhe
                        titulo="Item do Contrato"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.descricao }}</detalhe
                    >
                    <detalhe
                        titulo="Seq RM"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.seqRm }}</detalhe
                    >
                    <detalhe
                        titulo="Valor Unitário"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.valorUnitario | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Quantidade"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.quantidade | currency2 }}</detalhe
                    >
                    <detalhe
                        titulo="Sub Total"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.subTotal | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Desconto"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.desconto | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Valor Total"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.valorTotal | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Total Rateado"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{ itemRequisicao.totalRateado | currency }}</detalhe
                    >
                    <detalhe
                        titulo="Saldo a Ser Rateado"
                        :size="size1"
                        v-if="itemRequisicao"
                        >{{
                            itemRequisicao.saldoASerRateado | currency
                        }}</detalhe
                    >
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-row>
                        <b-col sm="12">
                            <b-form-group
                                :state="$v.valorRateado.$error ? false : null"
                                :invalid-feedback="valorRateadoValido"
                            >
                                <label>Valor</label>
                                <money
                                    ref="valorRateado"
                                    v-model="valorRateado"
                                    v-bind="money"
                                    class="form-control text-right"
                                    @input.native="$v.valorRateado.$touch()"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="selecionarItem()"
                >
                    Inserir</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        itemRequisicao: {
            type: Object
        }
    },

    data() {
        return {
            valorRateado: 0,
            mostrarModal: false,
            erros: [],
            size1: '130',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    validations: {
        valorRateado: {
            required,
            valorMinimo() {
                return this.valorRateado > 0
            },
            valorMaximo(){
                return this.valorRateado <=
                        Number.parseFloat(
                            this.itemRequisicao.saldoASerRateado
                        ).toFixed(2) 
            }
        }
    },

    methods: {
        fecharModal() {
            this.valorRateado = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
            this.valorRateado = this.itemRequisicao.saldoASerRateado
        },

        preencherModal() {},

        selecionarItem() {
            let itemDto = {
                idItemRequisicao: this.itemRequisicao.idItemRequisicao,
                valorRateado: this.valorRateado
            }
            this.$emit('selecionarItem', itemDto)
            this.fecharModal()
        }
    },

    computed: {
        valorRateadoValido() {
            if (!this.$v.valorRateado.valorMinimo) {
                return "O valor deve ser maior que 0"
            }
            if (!this.$v.valorRateado.valorMaximo) {
                return "O valor deve ser menor que o saldo disponivel"
            }
            return ''
        }
    }
}
</script>
